import React, { useState } from 'react';
import './ContactUs.css';

// ── SVG Icons ──────────────────────────────────────────────
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

const ArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

// ── Data ───────────────────────────────────────────────────
const TEAM_CONTACTS = [
  {
    initials: 'KN',
    name: 'K. Nedunchezian',
    nickname: 'Nedu',
    role: 'Director & Operations Head',
    phone: '+65 9239 8494',
    phoneRaw: '+6592398494',
    email: 'info@gskgeotech.com',
    expertise: 'Geotechnical Investigation, Recharge Wells, Ground Improvement',
  },
  {
    initials: 'MS',
    name: 'M. Subenthiran',
    nickname: 'Suben',
    role: 'General Manager',
    phone: '+65 9027 1160',
    phoneRaw: '+6590271160',
    email: 'info@gskgeotech.com',
    expertise: 'Ground Improvement Works, Design & Execution',
  },
  {
    initials: 'KG',
    name: 'Killiyappan Gopal',
    nickname: null,
    role: 'Major Shareholder & Director',
    phone: '+65 9067 4198',
    phoneRaw: '+6590674198',
    email: 'info@gskgeotech.com',
    expertise: 'Director of JAK Engineering & Jae Hwan Construction',
  },
];

const CONTACT_INFO = [
  {
    icon: <PhoneIcon />,
    label: 'Phone — Nedu',
    value: '+65 9239 8494',
    href: 'tel:+6592398494',
  },
  {
    icon: <PhoneIcon />,
    label: 'Phone — Suben',
    value: '+65 9027 1160',
    href: 'tel:+6590271160',
  },
  {
    icon: <PhoneIcon />,
    label: 'Phone — Gopal',
    value: '+65 9067 4198',
    href: 'tel:+6590674198',
  },
  {
    icon: <MailIcon />,
    label: 'Email',
    value: 'info@gskgeotech.com',
    href: 'mailto:info@gskgeotech.com',
  },
  {
    icon: <MapPinIcon />,
    label: 'Address',
    value: '19 Veersamy Road, Singapore 207350',
    href: 'https://maps.google.com/?q=19+Veersamy+Road+Singapore+207350',
  },
  {
    icon: <ClockIcon />,
    label: 'Working Hours',
    value: 'Mon – Sat: 8:00 AM – 6:00 PM',
    href: null,
  },
];

const SERVICES_LIST = [
  'Soil Investigation',
  'Recharge / Relief Well',
  'Pumping Test',
  'TAM Grouting',
  'Fissure Grouting',
  'JET Grouting',
  'Instrumentation & Monitoring',
  'Shaft & Pipe Jacking',
  'Others / Not Sure',
];

// ── Component ──────────────────────────────────────────────
export default function ContactUs() {
  const [form, setForm] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ⚠️ Replace this with YOUR OWN Formspree endpoint (from formspree.io)
  const FORMSPREE_ENDPOINT = 'https://formspree.io/f/meaqbgwo';

  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          name: form.name,
          company: form.company,
          email: form.email,
          phone: form.phone,
          service: form.service,
          message: form.message,
          _subject: `New Enquiry from ${form.name || 'Website Contact Form'}`,
        }),
      });

      if (response.ok) {
        setSubmitted(true);
        setForm({ name: '', company: '', email: '', phone: '', service: '', message: '' });
      } else {
        setError('Something went wrong. Please try again or call/email us directly.');
      }
    } catch (err) {
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cu-page">

      {/* ── HERO ── */}
      <section className="cu-hero">
        <div className="cu-hero-overlay" />
        <div className="cu-hero-content">
          <div className="cu-hero-badge">
            <span className="cu-badge-dot" />
            CONTACT US
          </div>
          <h1 className="cu-hero-title">
            LET'S START A<br />
            <span className="cu-orange">CONVERSATION</span>
          </h1>
          <p className="cu-hero-sub">
            GSK GEOTECH PTE LTD &nbsp;·&nbsp; SINGAPORE &nbsp;·&nbsp; EST. 2021
          </p>
        </div>
        <div className="cu-hero-scroll">
          <span>SCROLL</span>
          <div className="cu-scroll-line" />
        </div>
      </section>

      {/* ── QUICK CONTACT BAR ── */}
      <section className="cu-quick-bar">
        <a href="tel:+6592398494" className="cu-quick-item">
          <span className="cu-quick-icon"><PhoneIcon /></span>
          <div>
            <div className="cu-quick-label">CALL NEDU</div>
            <div className="cu-quick-value">+65 9239 8494</div>
          </div>
        </a>
        <div className="cu-quick-divider" />
        <a href="tel:+6590271160" className="cu-quick-item">
          <span className="cu-quick-icon"><PhoneIcon /></span>
          <div>
            <div className="cu-quick-label">CALL SUBEN</div>
            <div className="cu-quick-value">+65 9027 1160</div>
          </div>
          
        </a>
        
        <div className="cu-quick-divider" />
        <a href="mailto:info@gskgeotech.com" className="cu-quick-item">
          <span className="cu-quick-icon"><MailIcon /></span>
          <div>
            <div className="cu-quick-label">EMAIL US</div>
            <div className="cu-quick-value">info@gskgeotech.com</div>
          </div>
        </a>
        <div className="cu-quick-divider" />
        <span className="cu-quick-item">
          <span className="cu-quick-icon"><ClockIcon /></span>
          <div>
            <div className="cu-quick-label">WORKING HOURS</div>
            <div className="cu-quick-value">Mon – Sat: 8AM – 6PM</div>
          </div>
        </span>
      </section>

      {/* ── MAIN CONTENT: FORM + INFO ── */}
      <section className="cu-main">
        <div className="cu-main-inner">

          {/* LEFT: Contact Form */}
          <div className="cu-form-col">
            <div className="cu-section-label">
              <span className="cu-label-line" />
              SEND US A MESSAGE
            </div>
            <h2 className="cu-form-title">
              Get In Touch With<br />
              <span className="cu-orange">Our Team</span>
            </h2>
            <p className="cu-form-desc">
              Fill in the form below and our team will get back to you within 24 hours.
            </p>

            {submitted ? (
              <div className="cu-success">
                <div className="cu-success-icon"><CheckIcon /></div>
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. Our team will contact you within 24 hours.</p>
                <button className="cu-success-btn" onClick={() => setSubmitted(false)}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="cu-form" onSubmit={handleSubmit}>
                <div className="cu-form-row">
                  <div className="cu-form-group">
                    <label className="cu-label">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      className="cu-input"
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="cu-form-group">
                    <label className="cu-label">Company Name</label>
                    <input
                      type="text"
                      name="company"
                      className="cu-input"
                      placeholder="Your company"
                      value={form.company}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="cu-form-row">
                  <div className="cu-form-group">
                    <label className="cu-label">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      className="cu-input"
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="cu-form-group">
                    <label className="cu-label">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      className="cu-input"
                      placeholder="+65 XXXX XXXX"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="cu-form-group">
                  <label className="cu-label">Service Required</label>
                  <select
                    name="service"
                    className="cu-input cu-select"
                    value={form.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service...</option>
                    {SERVICES_LIST.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>

                <div className="cu-form-group">
                  <label className="cu-label">Project Details *</label>
                  <textarea
                    name="message"
                    className="cu-input cu-textarea"
                    placeholder="Tell us about your project — location, scope, timeline..."
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={5}
                  />
                </div>

                {error && <p className="cu-form-error">{error}</p>}

                <button type="submit" className="cu-submit-btn" disabled={loading}>
                  {loading ? (
                    <span className="cu-spinner" />
                  ) : (
                    <>SEND MESSAGE <ArrowRight /></>
                  )}
                </button>
              </form>
            )}
          </div>

          {/* RIGHT: Contact Info */}
          <div className="cu-info-col">
            <div className="cu-section-label">
              <span className="cu-label-line" />
              CONTACT INFORMATION
            </div>
            <h2 className="cu-info-title">
              Reach Us<br />
              <span className="cu-orange">Directly</span>
            </h2>

            <div className="cu-info-list">
              {CONTACT_INFO.map((item, i) => (
                <div key={i} className="cu-info-item">
                  <div className="cu-info-icon">{item.icon}</div>
                  <div className="cu-info-body">
                    <div className="cu-info-label">{item.label}</div>
                    {item.href ? (
                      <a href={item.href} className="cu-info-value cu-info-link" target={item.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                        {item.value}
                      </a>
                    ) : (
                      <div className="cu-info-value">{item.value}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Map Embed */}
            <div className="cu-map-wrap">
              <div className="cu-map-label">
                <span className="cu-label-line" />
                OUR LOCATION
              </div>
              <div className="cu-map-container">
                <iframe
                  title="GSK Geotech Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7554!2d103.8480!3d1.3138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19b0b4a7f1a7%3A0x1234!2s19+Veersamy+Rd%2C+Singapore+207350!5e0!3m2!1sen!2ssg!4v1234567890"
                  width="100%"
                  height="220"
                  style={{ border: 0, borderRadius: '4px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <a
                href="https://maps.google.com/?q=19+Veersamy+Road+Singapore+207350"
                target="_blank"
                rel="noreferrer"
                className="cu-map-link"
              >
                Open in Google Maps <ArrowRight />
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* ── TEAM CONTACTS ── */}
      <section className="cu-team">
        <div className="cu-team-inner">
          <div className="cu-section-label centered">
            <span className="cu-label-line" />
            SPEAK DIRECTLY TO OUR TEAM
            <span className="cu-label-line" />
          </div>
          <h2 className="cu-team-title">
            Contact Our <span className="cu-orange">Key Personnel</span>
          </h2>
          <p className="cu-team-sub">
            Reach out directly to our experienced team for any geotechnical enquiries.
          </p>

          <div className="cu-team-grid">
            {TEAM_CONTACTS.map((m, i) => (
              <div key={i} className="cu-team-card">
                {/* Photo hidden for now — shows a circular initials badge
                    instead (matches the home page team carousel).
                    Bring the <img> back once real team photos are ready. */}
                <div className="cu-team-avatar">
                  <span className="cu-team-initials">{m.initials}</span>
                </div>
                <div className="cu-team-body">
                  <h3 className="cu-team-name">
                    <span className="cu-orange">{m.name.charAt(0)}.</span>{' '}
                    {m.name.split(' ').slice(1).join(' ')}
                    {m.nickname && <span className="cu-team-nick"> ({m.nickname})</span>}
                  </h3>
                  <div className="cu-team-role">{m.role}</div>
                  <div className="cu-team-divider" />
                  <div className="cu-team-expertise">{m.expertise}</div>
                  <div className="cu-team-actions">
                    {m.phoneRaw && (
                      <a href={`tel:${m.phoneRaw}`} className="cu-team-btn cu-team-btn-primary">
                        <PhoneIcon /> {m.phone}
                      </a>
                    )}
                    <a href={`mailto:${m.email}`} className={"cu-team-btn " + (m.phoneRaw ? "cu-team-btn-secondary" : "cu-team-btn-primary")}>
                      <MailIcon /> Email
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      

    </div>
  );
}